import { gql } from "@apollo/client";

export const PUBLIC_START_LEAD = gql`
  mutation PublicStartLead(
    $token: String!
    $household: PublicHouseholdInput!
    $primary: PublicPrimaryInput!
    $members: [PublicHouseholdMemberInput!]
    $context: PublicLeadContextInput
    $observations: String
    $captchaToken: String!
  ) {
    publicStartLead(
      token: $token
      household: $household
      primary: $primary
      members: $members
      context: $context
      observations: $observations
      captchaToken: $captchaToken
    ) {
      success
      leadId
      metadata
      errors {
        field
        message
      }
    }
  }
`;

export const PUBLIC_UPDATE_HOUSEHOLD = gql`
  mutation PublicUpdateHousehold(
    $token: String!
    $leadId: ID!
    $household: PublicHouseholdInput
    $members: [PublicHouseholdMemberInput!]
    $wizardStep: String
  ) {
    publicUpdateHousehold(
      token: $token
      leadId: $leadId
      household: $household
      members: $members
      wizardStep: $wizardStep
    ) {
      success
      metadata
      errors {
        field
        message
      }
    }
  }
`;

export const PUBLIC_CONFIRM_PLAN = gql`
  mutation PublicConfirmPlan(
    $token: String!
    $leadId: ID!
    $planSelection: PublicPlanSelectionInput!
    $planResults: PublicPlanResultsInput
    $signatureFormId: String
    $agentId: String
    $sendEmail: Boolean
    $sendSms: Boolean
    $getSigningLink: Boolean
  ) {
    publicConfirmPlan(
      token: $token
      leadId: $leadId
      planSelection: $planSelection
      planResults: $planResults
      signatureFormId: $signatureFormId
      agentId: $agentId
      sendEmail: $sendEmail
      sendSms: $sendSms
      getSigningLink: $getSigningLink
    ) {
      success
      metadata
      signingLink
      consentHtml
      errors {
        field
        message
      }
    }
  }
`;

export const PUBLIC_CHECK_CONSENT = gql`
  mutation PublicCheckConsent($token: String!, $leadId: ID!) {
    publicCheckConsent(token: $token, leadId: $leadId) {
      success
      status
      metadata
      errors {
        field
        message
      }
    }
  }
`;

export const PUBLIC_INIT_IDENTITY = gql`
  mutation PublicInitIdentity(
    $token: String!
    $leadId: ID!
    $sendSms: Boolean
    $sendEmail: Boolean
    $language: String
  ) {
    publicInitIdentity(
      token: $token
      leadId: $leadId
      sendSms: $sendSms
      sendEmail: $sendEmail
      language: $language
    ) {
      success
      identityToken
      smsSent
      emailSent
      metadata
      errors {
        field
        message
      }
    }
  }
`;

export const PUBLIC_VERIFY_IDENTITY_OTP = gql`
  mutation PublicVerifyIdentityOtp(
    $token: String!
    $leadId: ID!
    $identityToken: String!
    $otpCode: String!
  ) {
    publicVerifyIdentityOtp(
      token: $token
      leadId: $leadId
      identityToken: $identityToken
      otpCode: $otpCode
    ) {
      success
      metadata
      errors {
        field
        message
      }
    }
  }
`;

export const PUBLIC_INIT_QUOTE = gql`
  mutation PublicInitQuote(
    $token: String!
    $leadId: ID!
    $sendSms: Boolean
    $sendEmail: Boolean
  ) {
    publicInitQuote(
      token: $token
      leadId: $leadId
      sendSms: $sendSms
      sendEmail: $sendEmail
    ) {
      success
      quoteToken
      smsSent
      emailSent
      errors {
        field
        message
      }
    }
  }
`;

export const PUBLIC_VERIFY_QUOTE_OTP = gql`
  mutation PublicVerifyQuoteOtp(
    $token: String!
    $leadId: ID!
    $quoteToken: String!
    $otpCode: String!
  ) {
    publicVerifyQuoteOtp(
      token: $token
      leadId: $leadId
      quoteToken: $quoteToken
      otpCode: $otpCode
    ) {
      success
      errors {
        field
        message
      }
    }
  }
`;

export const PUBLIC_CREATE_QUOTE = gql`
  mutation PublicCreateQuote(
    $token: String!
    $leadId: ID!
    $quoteToken: String
    $holder: PublicQuoteHolderInput!
    $members: [PublicQuoteMemberInput!]
    $payment: PublicQuotePaymentInput!
  ) {
    publicCreateQuote(
      token: $token
      leadId: $leadId
      quoteToken: $quoteToken
      holder: $holder
      members: $members
      payment: $payment
    ) {
      success
      policyId
      metadata
      errors {
        field
        message
      }
    }
  }
`;

export const PUBLIC_LEAD = gql`
  query PublicLead($token: String!, $leadId: ID!) {
    publicLead(token: $token, leadId: $leadId)
  }
`;

export const PUBLIC_SIGNATURE_STATUS = gql`
  query PublicSignatureStatus($token: String!, $leadId: ID!) {
    publicSignatureStatus(token: $token, leadId: $leadId)
  }
`;

export const PUBLIC_UPDATE_LEAD_STAGE = gql`
  mutation PublicUpdateLeadStage(
    $token: String!
    $leadId: ID!
    $stagePipelineId: Int!
  ) {
    publicUpdateLeadStage(
      token: $token
      leadId: $leadId
      stagePipelineId: $stagePipelineId
    ) {
      success
      leadId
      stagePipelineId
      errors {
        field
        message
      }
    }
  }
`;
export const PUBLIC_CONFIG = gql`
  query PublicConfig($token: String!, $slug: String) {
    publicConfig(token: $token, slug: $slug)
  }
`;
